import { useEffect } from 'react';
import { history } from 'Store';
import { routes } from 'Constants/routes';
import View from './view';

const SuccessStep = (): JSX.Element => {
  useEffect(() => {
    if (!window.location.search) {
      history.push(routes.DASHBOARD);
    }
  }, []);

  return <View />;
};

export default SuccessStep;
